import React, { lazy } from "react";

import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import Page from "components/Page";
import PageLoadingSkeleton from "components/PageLoadingSkeleton";

const RemoteBranding = lazy(() => import("codat-auth-settings-ui/Branding"));

export const Branding = () => {
  return (
    <Page>
      <React.Suspense fallback={<PageLoadingSkeleton />}>
        <ErrorBoundary>
          <RemoteBranding />
        </ErrorBoundary>
      </React.Suspense>
    </Page>
  );
};
